import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useUnmount } from 'usehooks-ts';
import { type ListingsRangeFilter } from '@/features/listing/types/listing-filters-types';
import InputRange from '@/ui/form-elements/input-range-slider/input-range';
interface ListingBudgetFilterProps {
  filter: ListingsRangeFilter;
  setFilterLink: (link: {
    pathname: string;
    searchParams: URLSearchParams;
  }) => void;
  filterLink: {
    pathname: string;
    searchParams: URLSearchParams;
  };
}
export default function ListingFilterRange(props) {
  const $ = _c(23);
  const {
    filter,
    filterLink,
    setFilterLink
  } = props;
  const searchParams = useSearchParams();
  const initialMinValue = filter.options.min.value;
  const initialMaxValue = filter.options.max.value;
  let t0;
  if ($[0] !== filter.options.max.defaultValue || $[1] !== filter.options.max.name || $[2] !== filter.options.min.defaultValue || $[3] !== filter.options.min.name || $[4] !== filterLink.pathname || $[5] !== filterLink.searchParams || $[6] !== setFilterLink) {
    t0 = (min, max) => {
      if (Number(min) === filter.options.min.defaultValue && Number(max) === filter.options.max.defaultValue) {
        filterLink.searchParams.delete(filter.options.min.name);
        filterLink.searchParams.delete(filter.options.max.name);
      } else {
        filterLink.searchParams.set(filter.options.min.name, min);
        filterLink.searchParams.set(filter.options.max.name, max);
      }
      setFilterLink({
        pathname: filterLink.pathname,
        searchParams: filterLink.searchParams
      });
    };
    $[0] = filter.options.max.defaultValue;
    $[1] = filter.options.max.name;
    $[2] = filter.options.min.defaultValue;
    $[3] = filter.options.min.name;
    $[4] = filterLink.pathname;
    $[5] = filterLink.searchParams;
    $[6] = setFilterLink;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  const creteNewSearchParams = t0;
  let t1;
  if ($[8] !== filterLink.pathname || $[9] !== searchParams || $[10] !== setFilterLink) {
    t1 = () => {
      setFilterLink({
        pathname: filterLink.pathname,
        searchParams: new URLSearchParams(searchParams.toString())
      });
    };
    $[8] = filterLink.pathname;
    $[9] = searchParams;
    $[10] = setFilterLink;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  useUnmount(t1);
  let t2;
  if ($[12] !== initialMaxValue || $[13] !== initialMinValue) {
    t2 = [initialMinValue, initialMaxValue];
    $[12] = initialMaxValue;
    $[13] = initialMinValue;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== creteNewSearchParams || $[16] !== filter.options.max.ariaLabel || $[17] !== filter.options.max.defaultValue || $[18] !== filter.options.min.ariaLabel || $[19] !== filter.options.min.defaultValue || $[20] !== filter.step || $[21] !== t2) {
    t3 = <InputRange range={true} step={filter.step} min={filter.options.min.defaultValue} max={filter.options.max.defaultValue} ariaLabelMin={filter.options.min.ariaLabel} ariaLabelMax={filter.options.max.ariaLabel} value={t2} allowCross={false} onChange={creteNewSearchParams} />;
    $[15] = creteNewSearchParams;
    $[16] = filter.options.max.ariaLabel;
    $[17] = filter.options.max.defaultValue;
    $[18] = filter.options.min.ariaLabel;
    $[19] = filter.options.min.defaultValue;
    $[20] = filter.step;
    $[21] = t2;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  return t3;
}